import { type HistoryGroup } from "@/features/history/utils";
import { type History } from "@repo/api";
import { Text } from "@repo/skapa";
import { t } from "@repo/translation";

import { HistoryListViewItem } from "./HistoryListViewItem";

interface Props {
  history: History | HistoryGroup;
}

// TODO: add new logics for new consent types
const getBody = (history: History) => {
  if (history.details?.consent_type === "FOLLOWUP_CONSENT") {
    if (history.details.consent_provided === true) {
      return t("prompt.customer_agreed_follow_up");
    }
    if (history.details.consent_provided === false) {
      return t("prompt.customer_did_not_agree_follow_up");
    }
  }

  // return default body
  return history.body;
};

export const ConsentHistoryItem = ({ history }: Props) => {
  return (
    <HistoryListViewItem
      history={history}
      control="default"
      title={history.title}
      description={<Text textStyle="Body.S">{getBody(history)}</Text>}
    />
  );
};
